import { Outlet } from "react-router-dom";

const PublicAuthLayout = () => {
  return (
    <div className="flex min-h-[calc(100dvh-76px)] items-center justify-center bg-gradient-to-br from-slate-950 via-blue-900 to-indigo-950 px-4 py-10">
      <div className="w-full max-w-6xl">
        <div className="rounded-2xl border border-white/10 bg-white/10 p-6 shadow-2xl shadow-slate-950/30 backdrop-blur-xl sm:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PublicAuthLayout;
